import type ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { action } from 'satcheljs/lib/legacy';
import { getSurfaceStore } from '../store/surfaceStore';

/**
 * Action to update the cached colors
 * TODO: WI 37323 we may remove this action once we have store implemented in color resolver
 */
export let updateCachedColors = action('updateCachedColors')(function updateCachedColors(
    colorScheme: ColorScheme,
    calendarFolderId: string
) {
    getSurfaceStore()
        .calendarItems.filter(item => item.ParentFolderId.Id === calendarFolderId)
        .forEach(calendarItem => {
            // Trigger re-render on all affected items
            let s = calendarItem.ItemId.Id;
            calendarItem.ItemId.Id = '';
            calendarItem.ItemId.Id = s;
        });
});

export default updateCachedColors;
